// Extraction type configs (video + UI chrome) — keys must match job.extractType
export const EXTRACT_CONFIGS = {
  rosin: {
    label: 'Rosin',
    icon: '🟡',
    durationTicks: 24 * 2,
    minGrams: 30,
    yieldRate: 0.24,
    priceMultiplier: 3.2,
    videoFile: 'rosin_loop.mp4',
    glowColor: 'rgba(255, 200, 50, 0.3)',
    borderColor: 'rgba(255, 193, 7, 0.6)',
  },
  wax: {
    label: 'Wax',
    icon: '🟤',
    durationTicks: 24 * 3,
    minGrams: 30,
    yieldRate: 0.28,
    priceMultiplier: 3.8,
    videoFile: 'wax_loop.mp4',
    glowColor: 'rgba(180, 100, 40, 0.3)',
    borderColor: 'rgba(160, 82, 45, 0.6)',
  },
  shatter: {
    label: 'Shatter',
    icon: '🔶',
    durationTicks: 24 * 4,
    minGrams: 30,
    yieldRate: 0.26,
    priceMultiplier: 5.0,
    videoFile: 'wax_loop.mp4',
    glowColor: 'rgba(255, 140, 0, 0.3)',
    borderColor: 'rgba(255, 140, 0, 0.6)',
  },
};
